import React,{Component} from 'react';
import ErrorBoundry from '../components/ErrorBoundry';
import CardList from '../components/CardList';
import SearchBox from '../components/SearchBox';
import Scroll from '../components/Scroll';
class App extends Component{
    constructor(){
    	super()
    	this.state={
    		robots: [],
    		searchfield:''
    	}
    }
    componentDidMount(){
    	fetch('https://jsonplaceholder.typicode.com/users')
          .then(response => response.json())
          .then(users =>this.setState({robots:users}));
    }
    onSearchChange=(event)=>{
    	this.setState({searchfield: event.target.value});
    }
	render(){
		const {robots,searchfield}=this.state;
		const filterRobots=robots.filter(robot=>{
        	return robot.name.toLowerCase().includes(searchfield.toLowerCase());
    });
    if(!robots.length){
    	 return <h1>Loading!!!</h1>
    }
    else{
			return(
			   <div className='tc'>
				   <h1 className='f1'>Robofriends</h1>
				   <SearchBox searchChange={this.onSearchChange}/>
           <Scroll>
             <ErrorBoundry>
			         <CardList robots={filterRobots}/>
             </ErrorBoundry> 
			     </Scroll>
			   </div>
			);
		}
    }
}
export default App;